/* EMA restock v4 — variant-aware, Afterpay-aware product placement.
   No external requests, storage, tracking, cart or checkout changes. */
(() => {
  'use strict';
  if (customElements.get('ema-restock')) return;

  class EMARestock extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._scope = this.dataset.mode === 'card'
        ? this.closest('product-card')
        : (this.closest('.js-product') || this.closest('.product-details') || document);

      this._change = event => {
        if (this.dataset.mode === 'card') {
          const input = event.target.closest && event.target.closest('[data-variant-id]');
          if (input && this._scope && this._scope.contains(input)) {
            this.select(input.dataset.variantId);
          }
        } else {
          const detail = event.detail || {};
          if (detail.product && String(detail.product.id) !== this.dataset.productId) return;
          this.select(detail.variant ? String(detail.variant.id) : '');
        }
      };

      this._event = this.dataset.mode === 'card' ? 'change' : 'on:variant:change';
      if (this._scope && this._scope.addEventListener) {
        this._scope.addEventListener(this._event, this._change);
      }

      this._ready = () => {
        if (this.dataset.mode !== 'inline') return;
        const picker = this._scope && this._scope.querySelector
          ? this._scope.querySelector('variant-picker')
          : null;
        const id = picker && 'variant' in picker && picker.variant
          ? String(picker.variant.id)
          : (this.dataset.selected || '');
        this.select(id);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._ready, { once: true });
      } else {
        this._ready();
      }
    }

    disconnectedCallback() {
      if (this._scope && this._scope.removeEventListener) {
        this._scope.removeEventListener(this._event, this._change);
      }
      document.removeEventListener('DOMContentLoaded', this._ready);
      if (this._observer) this._observer.disconnect();
      (this._timers || []).forEach(timer => window.clearTimeout(timer));
      this._timers = [];
      if (this._mirror && this._mirror.isConnected) this._mirror.remove();
      this._connected = false;
    }

    select(id) {
      let found = false;
      this.querySelectorAll('[data-restock-variant]').forEach(option => {
        const show = option.dataset.restockVariant === String(id);
        option.hidden = !show;
        found = found || show;
      });
      const summary = this.querySelector('[data-restock-summary]');
      if (summary) summary.hidden = true;

      if (this.dataset.mode === 'inline') {
        this.hidden = !found;
        this._syncBackorder(found);
      } else {
        this.hidden = !found;
      }
    }

    _syncBackorder(found) {
      const root = this.closest('.product-info') || this._scope;
      const legacy = root && root.querySelector ? root.querySelector('.product-backorder') : null;
      if (legacy) legacy.hidden = Boolean(found);
    }

  }

  customElements.define('ema-restock', EMARestock);
})();
